/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { Provider, useDispatch, useSelector } from 'react-redux';
import store, { detailViewActions } from '../../../Helpers/Stores/detailViewStore';
import { Fragment, useEffect, useState } from 'react';
import Button from './Elements/Button';
import loadJsonPost from '../Utils/jsonPost';
import LocalStorage from '../../../Helpers/MFXLocalStorage';
import loadJsonData from '../Utils/jsonGet';
import loadJsonPut from '../Utils/jsonPut';
import { useParams, useSearchParams } from 'react-router-dom';
import Checkbox from './Elements/ElementCheckbox';
import GenericElement from './Elements/GenericElements';
import URLS from '../Utils/URLs.API';
import SavedModal from './Elements/SavedModal';
import loadJsonDelete from '../Utils/jsonDelete';
import Info from '../Elements/Info';
import TimeRecordingTypeDesigner from './Elements/TimeRecordingTypeDesigner';
import ConfirmPopup from '../Elements/ConfirmPopup';
import ReactSelect from '../Elements/ReactSelect';

interface IGenericViewEditorProps {
    name: string | undefined;
    menuData: any;
}

/* --------------- IMPORT ALL FILES from Detailviews ------------- */

function importAll(r: any) {
    let data = {};
    r.keys().forEach((item: any) => {
        (data as any)[item.replace('./', '').replace(/\.(json)$/, '')] = r(item);
    });
    return data;
}
const defaultViews = importAll((require as any).context('../../../Data/Designer/Defaultviews', false, /\.(json)$/));

/* ---------------------------------------------------------
    --------------- GenericDetailViewEditor (and AddViewEditor) ------------- */

export default function GenericDetailViewEditor(props: IGenericViewEditorProps) {
    const viewData = useSelector((state: RootState) => state.viewData);
    const name = useParams();

    const [searchParams] = useSearchParams();
    const type = searchParams.get('type');
    const viewType = searchParams.get('viewtype');

    const dispatch = useDispatch();
    const [dataLoaded, setDataLoaded] = useState(false);
    const [curLayoutName, setCurLayoutName] = useState(useSearchParams()[0].get('layoutName') ?? 'default');
    const [layoutNames, setLayoutNames] = useState(null as any);
    const [saveMessage, setSaveMessage] = useState(null as any);
    const [checkboxSearch, setCheckboxSearch] = useState('' as any);
    const [userGroups, setUserGroups] = useState(null as any);
    const [valueAccord, setValueAccord]: any = useState({});
    const [settingsSelected, setSettingsSelected] = useState({
        default: false,
        checkList: false,
        element: false,
    });
    const [curGenericElement, setCurGenericElement] = useState({ elementClicked: false, designData: {} as any, key: '', customData: '' });
    const [confirmOpen, setConfirmOpen] = useState(false);

    const [withType, setWithType] = useState(false);
    const [withDBName, setWithDBName] = useState(false);
    //defaultData from JSON

    function showSettings(type: string) {
        let newSettingsObject = { ...settingsSelected } as any;
        Object.keys(newSettingsObject).forEach(settings => {
            if (settings === type) newSettingsObject[type] = !newSettingsObject[type];
            else newSettingsObject[settings] = false;
        });
        setSettingsSelected(newSettingsObject);
    }

    function autoFillFromDefaults(curData) {
        const root = curData?.Data?.[0];
        if (!root) return;

        for (const sectionName in root) {
            const section = root[sectionName];
            if (!section?.FillData) continue;

            const defaultTemplate = defaultViews?.[section.Origin]?.Data?.[0];
            if (!defaultTemplate) continue;

            const cloned = structuredClone(defaultTemplate);
            const keyPrefix = section.Key + '-';
            const readOnly = section.ReadOnly;

            normalizeKeysAndReadOnly(cloned, keyPrefix, readOnly);

            root[sectionName] = cloned;
        }
    }

    function normalizeKeysAndReadOnly(obj, keyPrefix, readOnly) {
        if (!obj || typeof obj !== 'object') return;

        if (obj.Key) {
            obj.Key = keyPrefix + obj.Key;
        }

        if (obj.ReadOnly !== undefined && readOnly !== undefined) {
            obj.ReadOnly = readOnly;
        }

        for (const k in obj) {
            normalizeKeysAndReadOnly(obj[k], keyPrefix, readOnly);
        }
    }

    function loadDataDefault(id = null) {
        let designerObject = {} as any;
        if (type) {
            let curData = (defaultViews as any)[type];

            autoFillFromDefaults(curData);

            if (curData[viewType + 'Elements']) {
                let shownElements = curData[viewType + 'Elements'][0];
                let preparedData = prepareData(curData.Data[0]);
                if (Array.isArray(shownElements)) {
                    // OLD 17.01.24
                    console.log(shownElements);
                    shownElements.forEach((entry: any) => {
                        console.log(preparedData);
                        designerObject[entry] = preparedData[entry];
                    });
                } else designerObject = shownElements;

                let data = { Data: curData.Data[0], viewData: name, DesignElements: designerObject, ID: id, ViewLabel: viewData.ViewLabel };
                dispatch(detailViewActions.init(data));
            }
        }
    }

    //#region UseEffect

    useEffect(() => {
        if (curLayoutName) {
            var newurl = window.location.href.split('?')[0] + ('?' + window.location.href.split('?')[1].split('&layoutName')[0] + '&layoutName=' + curLayoutName);
            window.history.pushState({ path: newurl }, '', encodeURI(newurl));
        }
    }, [curLayoutName]);

    useEffect(() => {
        setCurGenericElement({ elementClicked: false, designData: {}, key: '', customData: '' });
        setDataLoaded(false);
        console.log(props);
        loadLayoutNames();
        getLayout();
        getUserGroups();
    }, [dispatch, viewType, type]);

    function getUserGroups() {
        loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.GetUserGroups)
            .then((data: any) => {
                setUserGroups(data.Data);
            })
            .catch(e => {
                console.log('No Usergroups found!');
            });
    }
    useEffect(() => {
        if (curGenericElement.elementClicked) {
            var genericElement = JSON.parse(JSON.stringify(curGenericElement));
            (genericElement.designData as any).Conditions = viewData.DesignElements[curGenericElement.key].Conditions;
            setCurGenericElement(genericElement);
        }
    }, [viewData?.DesignElements[curGenericElement?.key]?.Conditions]);
    //#endregion UseEffect

    //#region Api Calls
    function getLayout(layoutname: string = curLayoutName) {
        setDataLoaded(false);
        loadDataDefault();
        loadJsonData('/' + LocalStorage?.getConnectionKey() + URLS.GetViewLayouts + props.name + '&LayoutName=' + layoutname)
            .then((data: any) => {
                if (data.Data) {
                    //overwriteDesigner(data.Data.Json, Data); //setCustomData
                    var designElements = data.Data.Json.DesignElements;
                    if (data.Data.Json.ElementsOrder) {
                        var x = {};
                        var count = 1;
                        data.Data.Json.ElementsOrder[0].forEach((el: any) => {
                            if (data.Data.Json.DesignElements[el]) {
                                x[el] = data.Data.Json.DesignElements[el];
                                x[el].Order = count;
                                count++;
                            }
                        });
                        designElements = x;
                    }
                    console.log(data);
                    dispatch(detailViewActions.changeViewSettings({ key: 'Settings', value: data.Data.Json.Settings }));
                    dispatch(detailViewActions.changeViewSettings({ key: 'DesignElements', value: designElements }));
                    dispatch(detailViewActions.changeViewSettings({ key: 'ID', value: data.Data.ID }));
                    dispatch(detailViewActions.changeViewSettings({ key: 'ViewLabel', value: data.Data.ViewLabel ?? '' }));
                } else {
                    dispatch(detailViewActions.changeViewSettings({ key: 'ID', value: null }));
                }
                setDataLoaded(true);
            })
            .catch(e => {
                console.log(e);
                console.log('Default Json Data!');
                setCurLayoutName('default');
                dispatch(detailViewActions.changeViewSettings({ key: 'ID', value: null }));
                setDataLoaded(true);
            });
    }

    function loadLayoutNames() {
        loadJsonData('/' + LocalStorage?.getConnectionKey() + '/api/Layout/GetBusinessProcessViewLayoutNames?ViewName=' + props.name).then((data: any) => {
            setLayoutNames(data.Data);
            if (data.Data.findIndex((l: any) => l.LayoutName === curLayoutName) === -1) {
                const idx = data.Data.findIndex((l: any) => l.LayoutName === 'default');
                setCurLayoutName(data.Data[idx > 0 ? idx : 0]?.LayoutName);
            }
        });
    }

    function saveViewData() {
        if (viewData.ID === null) {
            console.log(viewData.Settings);
            loadJsonPost('/' + LocalStorage?.getConnectionKey() + URLS.PostBusinessProcessView, {
                CreateData: { ConfigData: JSON.stringify({ DesignElements: viewData.DesignElements, Settings: viewData.Settings ?? {} }), LayoutName: curLayoutName, ViewName: props.name, ViewType: viewType, ViewLabel: viewData.ViewLabel },
            }).then(data => {
                if (data.Meta.Success) setSaveMessage({ message: 14445, success: true });
                else setSaveMessage({ message: 13656, success: false });
            });
        } else {
            loadJsonPut('/' + LocalStorage?.getConnectionKey() + URLS.PutBusinessProcessView, {
                UpdateData: {
                    ConfigData: JSON.stringify({ DesignElements: viewData.DesignElements, Settings: viewData.Settings ?? {} }),
                    LayoutName: curLayoutName,
                    ViewName: props.name,
                    ID: viewData.ID,
                    ViewType: viewType,
                    ViewLabel: viewData.ViewLabel,
                },
            }).then(data => {
                if (data.Meta.Success) setSaveMessage({ message: 14445, success: true });
                else setSaveMessage({ message: 14847, success: false });
            });
        }
        setCurGenericElement({ elementClicked: false, designData: {}, key: '', customData: '' });
    }

    function deleteViewData() {
        if (viewData.ID) {
            loadJsonDelete('/' + LocalStorage?.getConnectionKey() + URLS.DeleteBusinessProcessView + '?Index=' + viewData.ID).then(data => {
                if (data.Meta.Success) {
                    setSaveMessage({ message: 14905, saveText: props.name + '-' + curLayoutName, success: true });
                    loadLayoutNames();
                    setConfirmOpen(false);
                }
            });
        }
        setCurLayoutName('default');
        getLayout('default'); // parameter needed, because viewdata are not updated immediately
    }

    //#endregion Api Calls

    //#region Dragable
    let target: any;
    let shadow: any;
    function dragStart(e: any) {
        shadow = e.target;
    }
    function dragOver(e: any) {
        e.preventDefault();
        var prev = target;
        target = e.target.closest('.mfx-generic-element');
        if (!target.id && !target.draggable) return;
        if (prev && prev !== target) {
            prev.style.borderLeft = '';
            prev.style.borderRight = '';
        }
        if (target !== shadow) {
            target.style[target.clientWidth / 2 > e.clientX - target.offsetLeft ? 'borderLeft' : 'borderRight'] = '3px solid #58fa7c';
            target.style[target.clientWidth / 2 < e.clientX - target.offsetLeft ? 'borderLeft' : 'borderRight'] = '';
        }
    }

    function dragEnd(e: any) {
        if (target) {
            target.style.borderLeft = '';
            target.style.borderRight = '';
            if (target?.id !== '' && shadow?.id !== '') dispatch(detailViewActions.setOrder({ target: target.id, shadow: shadow.id, insertBefore: target.clientWidth / 2 > e.clientX - target.offsetLeft }));
            else alert('Drag and Drop failed since the object it was dropped on was not part of the Table');
        }
    }

    //#endregion Dragable

    //#region Event Handlers

    function addElement(settingsObject: any) {
        var data = { ...settingsObject };
        dispatch(detailViewActions.addData(data));
    }

    function handleCreate(inputValue: any) {
        setCurLayoutName(inputValue);
        setLayoutNames([...layoutNames, { LayoutName: inputValue }]);
        loadDataDefault();
    }
    //#endregion Event Handlers

    //#region Helper Methods

    function renderOption(newEntry: any) {
        return (
            <option key={newEntry.Key} value={newEntry.Key}>
                {newEntry.Key}
            </option>
        );
    }

    // The Type:Option isn't used yet
    function ViewData(curData: Object, index: string, type: string, withType = false, withDBName = false): any {
        if (Array.isArray(curData)) curData = curData[0];
        if (!Object.entries(curData).find((d: any) => d[1].Designable)) {
            return null;
        }
        return (
            <>
                {curData &&
                    Object.entries(curData)
                        .filter((data: any) => {
                            if (type !== 'Option' && data[1].Label) return window.Dictionary.getTranslation(data[1].Label).toLowerCase().includes(checkboxSearch.toLowerCase());
                            return true;
                        })
                        .sort((a, b) => {
                            return !a[1].Designable && b[1].Designable ? 1 : window.Dictionary.getTranslation(a[1].Label) > window.Dictionary.getTranslation(b[1].Label) ? 1 : -1;
                        })
                        .map((key, idx) => {
                            console.log(withType);
                            console.log(withDBName);

                            if (type === 'Option' && typeof key[1] === 'object' && key[1].Designable === true && (key[1].Label || key[1].Name)) {
                                return (
                                    <option key={(index ? index + '-' : '') + key[0]} value={key[1].Key}>
                                        {(index ? index + '-' : '') + window.Dictionary.getTranslation(key[1].Label ?? key[1].Name ?? '') +  (withType && key[1].Elementtype ? ' (' + (key[1].Type ?? key[1].Elementtype) + ')' : '') + (withDBName && key[1].DBName ? ' (' + key[1].DBName + ')' : '')}
                                    </option>
                                );
                            } else if (typeof key[1] === 'object' && key[1].Designable === true && (key[1].Label || key[1].Name)) {
                                return (
                                    <div key={idx}>
                                        <Checkbox
                                            checked={Object.entries(viewData.DesignElements).find((d: any) => d[1].Key === key[1].Key) ? true : false}
                                            key={key[1].Key}
                                            designData={key[1]}
                                            uniqueKey={'Data-' + key[1].Key}
                                            onChangeHandler={(settingsObject: object) => addElement(settingsObject)}
                                            withType={withType}
                                            withDBName={withDBName}
                                        />
                                    </div>
                                );
                            } else if ((Array.isArray(key[1]) || typeof key[1] === 'object') && !key[1].Designable && key[1].Designable !== false && ViewData(key[1], (index ? index + '-' : '') + key[0], type)) {
                                if (type === 'Option') {
                                    return <>{ViewData(key[1], (index ? index + '-' : '') + key[0], type,withType,withDBName)}</>;
                                }
                                return (
                                    <Fragment key={idx}>
                                        <h4 onClick={() => setValueAccord({ ...valueAccord, [key[0]]: !valueAccord[key[0]] })}>{'-'.repeat(index ? index.split('-').length + 1 : 1) + key[0]}</h4>
                                        {(valueAccord[key[0]] || (checkboxSearch != null && checkboxSearch !== '')) && ViewData(key[1], (index ? index + '-' : '') + key[0], type, withType,withDBName)}
                                    </Fragment>
                                );
                            }
                            return <></>;
                        })}
            </>
        );
    }
    //#endregion Helper Methods

    //#region screen resize
    const [width, setWidth] = useState(75);
    function resizeScreen(e: any) {
            if (e.clientX === 0) return;
            setWidth((e.pageX / window.innerWidth) * 100);
    }
    //#endregion screen resize

    function getEmptyKey() {
        var count = Object.entries(viewData.DesignElements).filter((el: any) => (el[1].Key as string).startsWith('EmptyElement-')).length;
        return 'EmptyElement-' + count;
    }

    useEffect(() => {
        console.log('ELEMENT CLICKED');
        console.log(curGenericElement?.elementClicked === true);
        console.log(settingsSelected);
        if (curGenericElement?.elementClicked && !settingsSelected.element) {
                        console.log('SetElement');

            showSettings('element');
        } else if(!settingsSelected.checkList && !settingsSelected.checkList) {
            console.log('SetCheck');
            showSettings('checkList');
        }
    }, [curGenericElement?.elementClicked]);
    console.log(settingsSelected);
    return (
        <Provider store={store}>
            <main id="mfx-generic-view-editor" className="mfx-gp-container detailview">
                {dataLoaded && (
                    <>
                        <div className="mfx-preview" style={{ gridTemplateColumns: width + '% 10px auto' }}>
                            <div id="mfx-generic-view-preview" className="mfx-gp-page">
                                <h1>
                                    {props.menuData && window.Dictionary.getTranslation(props.menuData.label)} ({curLayoutName}){' '}
                                </h1>
                                <div className="mfx-view">
                                    <div className="mfx-container detailviewcontainer" style={{ gridTemplateColumns: 'repeat(' + (viewData.Settings?.Columns ?? 2) + ', 1fr)' }}>
                                        {viewData.DesignElements &&
                                            Object.entries(viewData.DesignElements)
                                                .sort((a: any, b: any) => {
                                                    return a[1].Order > b[1].Order ? 1 : -1;
                                                })
                                                .map((key: any, idx: number) => {
                                                    let entry = key[1];
                                                    let activeClass = curGenericElement.key === entry.Key ? 'active' : '';
                                                    if (entry)
                                                        return (
                                                            <div className={activeClass}>
                                                                <GenericElement
                                                                    designData={entry as any}
                                                                    disableMode={true}
                                                                    index={idx}
                                                                    onDragEnd={dragEnd}
                                                                    onDragStart={dragStart}
                                                                    onDragOver={dragOver}
                                                                    onElementClicked={() => {
                                                                        if (curGenericElement.key === (entry as any).Key) {
                                                                            setCurGenericElement({ elementClicked: false, designData: {}, key: '', customData: '' });
                                                                        } else {
                                                                            setCurGenericElement({ elementClicked: true, designData: entry, key: (entry as any).Key, customData: (entry as any).DefaultValue });
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        );

                                                    return <></>;
                                                })}
                                    </div>
                                </div>
                                <div className="grid-common-buttons">
                                    <Button onClickHandler={() => loadDataDefault(viewData.ID)} iconClass="fa-solid fa-rotate-right" dll="Load Default" />
                                    <Button iconClass="icon-close" onClickHandler={getLayout} dll={1472} />
                                    {curLayoutName !== 'default' && <Button iconClass="icon-delete" important={false} onClickHandler={e => setConfirmOpen(true)} dll={64} />}
                                    <Button id="button-save" iconClass="icon-save" important={true} onClickHandler={saveViewData} dll={63} />
                                </div>
                            </div>

                            <div className="mfx-resizer" draggable={true} onDrag={resizeScreen}></div>

                            <div className="mfx-sidebar">
                                <h2>
                                    {window.Dictionary.getTranslation(134)}
                                    <Info text={window.Dictionary.getTranslation(15407)} />
                                </h2>

                                <ReactSelect
                                    onChange={(newValue: any) => {
                                        setCurLayoutName(newValue.value);
                                        getLayout(newValue.value);
                                    }}
                                    onCreateOption={handleCreate}
                                    options={layoutNames?.map((name: any) => {
                                        return { label: name.LayoutName, value: name.LayoutName };
                                    })}
                                    value={{ label: curLayoutName, value: curLayoutName }}
                                />

                                <div className="mfx-settings-accordion">
                                    <h3 className={settingsSelected.checkList ? 'active' : ''} id={'accordion-settings-checkList'} onClick={() => showSettings('checkList')}>
                                        {window.Dictionary.getTranslation(16883)}
                                    </h3>
                                    {settingsSelected.checkList && (
                                        <>
                                            <div className="mfx-checkbox-element">
                                                <input
                                                    id="withTypeCheckbox"
                                                    type="checkbox"
                                                    checked={withType}
                                                    onClick={(e: any) => {
                                                        setWithType(e.target.checked);
                                                    }}
                                                />
                                                <label>
                                                    {window.Dictionary.getTranslation(15166)} <Info text={window.Dictionary.getTranslation(15402)} />
                                                </label>
                                            </div>
                                            <div className="mfx-checkbox-element">
                                                <input
                                                    id="withDBNameCheckbox"
                                                    type="checkbox"
                                                    checked={withDBName}
                                                    onClick={(e: any) => {
                                                        setWithDBName(e.target.checked);
                                                    }}
                                                />
                                                <label>
                                                    {window.Dictionary.getTranslation(17431)} <Info text={window.Dictionary.getTranslation(17433)} />
                                                </label>
                                            </div>
                                            <input id="checkboxsearch" placeholder={window.Dictionary.getTranslation(162)} value={checkboxSearch} onChange={e => setCheckboxSearch(e.target.value)} />
                                            <div className="mfx-element-selection">
                                                {ViewData(viewData.Data, '', 'Checkbox', withType, withDBName)}{' '}
                                                <div>
                                                    <button
                                                        onClick={e => {
                                                            var key = getEmptyKey();
                                                            addElement({ key: key, newValue: true, label: '', designData: { Elementtype: 'empty', Key: key } });
                                                        }}>
                                                        Add Empty
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div className="mfx-settings-accordion">
                                    <h3 className={settingsSelected.default ? 'active' : ''} id={'accordion-settings-default'} onClick={() => showSettings('default')}>
                                        {window.Dictionary.getTranslation(14466)}
                                    </h3>
                                    {settingsSelected.default && (
                                        <>
                                            <div className="mfx-dropdown-element">
                                                <label>{window.Dictionary.getTranslation(6254)}</label>
                                                <select
                                                    value={viewData.Settings?.Columns ?? 2}
                                                    onChange={e => {
                                                        dispatch(detailViewActions.changeDefaultSettings({ target: 'Columns', value: e.target.value }));
                                                    }}>
                                                    <option value={1}>1</option>
                                                    <option value={2}>2</option>
                                                    <option value={3}>3</option>
                                                    <option value={4}>4</option>
                                                </select>
                                            </div>
                                            <div key={'ShowOverflow'}>
                                                <Checkbox
                                                    checked={viewData.Settings?.Overflow ? true : false}
                                                    key={'ShowOverflow'}
                                                    designData={{ Label: 17300, Key: 'ShowOverflow' }}
                                                    uniqueKey={'Data-Show-Overflow'}
                                                    onChangeHandler={(settingsObject: any) => dispatch(detailViewActions.changeDefaultSettings({ target: 'ShowOverflow', value: settingsObject.newValue }))}
                                                />
                                            </div>
                                            <div>
                                                <label>{window.Dictionary.getTranslation(17303)}</label>
                                                <input type="number" value={viewData.Settings?.MaxHeight ?? null} onChange={(e: any) => dispatch(detailViewActions.changeDefaultSettings({ target: 'MaxHeight', value: e.target.value }))} />
                                            </div>
                                            <label htmlFor="OnlyEditableFor">{window.Dictionary.getTranslation(17520)}</label>
                                            <ReactSelect
                                                onChange={(newValue: any) => {
                                                    var val = newValue.map(v => v.value);
                                                    dispatch(detailViewActions.changeDefaultSettings({ target: 'OnlyEditableFor', value: val }));
                                                }}
                                                isMulti
                                                options={userGroups?.map((group: any) => {
                                                    return { label: group.Name, value: group.Name };
                                                })}
                                                value={viewData.Settings?.OnlyEditableFor?.map((group: any) => {
                                                    return { label: group, value: group };
                                                })}
                                            />
                                        </>
                                    )}
                                </div>
                                <div className="mfx-settings-accordion">
                                    <h3 className={settingsSelected.element ? 'active' : ''} id={'accordion-settings-element'} onClick={() => showSettings('element')}>
                                        {window.Dictionary.getTranslation(17302)}
                                    </h3>
                                    {settingsSelected.element && (
                                        <>
                                            {curGenericElement.elementClicked && (
                                                <div className="customsettings">
                                                    <h3>{window.Dictionary.getTranslation(1109)}</h3>
                                                    <h5>{curGenericElement.key}</h5>
                                                    <div className="customsettings-elements">
                                                        <div>
                                                            <label htmlFor="label">{window.Dictionary.getTranslation(14469)}</label>
                                                            <input
                                                                name="label"
                                                                type="text"
                                                                id="label"
                                                                value={window.Dictionary.getTranslation((viewData.DesignElements[curGenericElement.key as any] as any).Label)}
                                                                onChange={e => {
                                                                    if (viewData.DesignElements[curGenericElement.key as any] as any) {
                                                                        setCurGenericElement({ ...curGenericElement, designData: { ...curGenericElement.designData, Label: e.target.value ? e.target.value : (viewData.DesignElements[curGenericElement.key as any] as any).DefaultLabel } });
                                                                        dispatch(
                                                                            detailViewActions.changeDesignElements({
                                                                                ...curGenericElement,
                                                                                element: { ...curGenericElement.designData, Label: e.target.value ? e.target.value : (viewData.DesignElements[curGenericElement.key as any] as any).DefaultLabel },
                                                                            }),
                                                                        );
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                        {curGenericElement.designData.Elementtype === 'timerecordingtype' && (
                                                            <div>
                                                                <TimeRecordingTypeDesigner
                                                                    designData={curGenericElement.designData}
                                                                    onChangeHandler={(data: any) => {
                                                                        setCurGenericElement({ ...curGenericElement, designData: { ...curGenericElement.designData, Options: data.newValue ?? data } });
                                                                        dispatch(detailViewActions.changeDesignElements({ ...curGenericElement, element: { ...curGenericElement.designData, Options: data.newValue ?? data } }));
                                                                    }}></TimeRecordingTypeDesigner>
                                                            </div>
                                                        )}
                                                        {curGenericElement.designData.Elementtype !== 'timerecordingtype' && (
                                                            <div>
                                                                <label htmlFor="defaultvalue">{window.Dictionary.getTranslation(5680)}</label>

                                                                <GenericElement
                                                                    disableMode={false}
                                                                    designData={curGenericElement.designData}
                                                                    getDropdownValues={true}
                                                                    noLabel={true}
                                                                    readOnly={false}
                                                                    onChangeHandler={(data: any) => {
                                                                        setCurGenericElement({ ...curGenericElement, designData: { ...curGenericElement.designData, DefaultValue: data.newValue ?? data } });
                                                                        dispatch(detailViewActions.changeDesignElements({ ...curGenericElement, element: { ...curGenericElement.designData, DefaultValue: data.newValue ?? data } }));
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                        <div>
                                                            <label>{window.Dictionary.getTranslation(15408)}</label>
                                                            <select
                                                                onChange={e => dispatch(detailViewActions.setConditions({ condition: { type: 'alternative', value: e.target.value }, key: curGenericElement.key }))}
                                                                value={curGenericElement.designData.Conditions && curGenericElement.designData.Conditions[0] ? curGenericElement.designData.Conditions[0].value : ''}>
                                                                <option value=""></option>
                                                                {viewData.Data &&
                                                                    Object.entries(viewData.DesignElements).map((entry: any, idx) => {
                                                                        if (curGenericElement.designData.Key === entry[1].Key) return <></>;
                                                                        let newEntry = { ...entry[1] };
                                                                        return renderOption(newEntry);
                                                                    })}
                                                            </select>
                                                        </div>
                                                        <div className="mfx-checkbox-element">
                                                            <input
                                                                name="required"
                                                                id="requiredcheckbox"
                                                                type="checkbox"
                                                                checked={curGenericElement.designData.Required || false}
                                                                onChange={e => {
                                                                    setCurGenericElement({ ...curGenericElement, designData: { ...curGenericElement.designData, Required: e.target.checked } });
                                                                    dispatch(detailViewActions.changeDesignElements({ ...curGenericElement, element: { ...curGenericElement.designData, Required: e.target.checked } }));
                                                                }}
                                                            />
                                                            <label htmlFor="requiredcheckbox">{window.Dictionary.getTranslation(325)}</label>
                                                        </div>
                                                        <div className="mfx-checkbox-element">
                                                            <input
                                                                name="readonly"
                                                                id="readonlycheckbox"
                                                                type="checkbox"
                                                                checked={curGenericElement.designData.ReadOnly || false}
                                                                onChange={e => {
                                                                    setCurGenericElement({ ...curGenericElement, designData: { ...curGenericElement.designData, ReadOnly: e.target.checked } });
                                                                    dispatch(detailViewActions.changeDesignElements({ ...curGenericElement, element: { ...curGenericElement.designData, ReadOnly: e.target.checked } }));
                                                                }}
                                                            />
                                                            <label htmlFor="readonlycheckbox">{window.Dictionary.getTranslation(14933)}</label>
                                                        </div>
                                                            <label htmlFor="fullAccessUsers">{window.Dictionary.getTranslation(15974)}</label>
                                                            <ReactSelect
                                                                onChange={(newValue: any) => {
                                                                    var val = newValue.map(v => v.value);
                                                                    setCurGenericElement({ ...curGenericElement, designData: { ...curGenericElement.designData, WriteGroups: val } });
                                                                    dispatch(detailViewActions.changeDesignElements({ ...curGenericElement, element: { ...curGenericElement.designData, WriteGroups: val } }));
                                                                }}
                                                                isMulti
                                                                key={curGenericElement.designData.Key}
                                                                options={userGroups?.map((group: any) => {
                                                                    return { label: group.Name, value: group.Name };
                                                                })}
                                                                value={curGenericElement.designData?.WriteGroups?.map((group: any) => {
                                                                    return { label: group, value: group };
                                                                })}
                                                            />
                                                        <button
                                                            onClick={e => {
                                                                var key = curGenericElement.designData.Key;
                                                                setCurGenericElement({ elementClicked: false, designData: {} as any, key: '', customData: '' });
                                                                addElement({ key: key, newValue: false });
                                                            }}>
                                                            Delete Element
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                            {!curGenericElement.elementClicked && <label>{window.Dictionary.getTranslation(17301)}</label>}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        {confirmOpen && (
                            <ConfirmPopup confirm={deleteViewData} stop={() => setConfirmOpen(false)}>
                                {window.Dictionary.getTranslation(16409)}
                            </ConfirmPopup>
                        )}
                        {saveMessage && <SavedModal saveMessage={saveMessage} closeIcon={true} handleClose={() => setSaveMessage(null)} />}
                    </>
                )}
            </main>
        </Provider>
    );
}

export function GenericDetailViewProvider(props: IGenericViewEditorProps) {
    return (
        <Provider store={store}>
            <GenericDetailViewEditor {...props} />
        </Provider>
    );
}
export type RootState = ReturnType<typeof store.getState>;

// OLD 17.01.24
function prepareData(data: any) {
    let preparedData = {} as any;
    Object.keys(data).forEach((key, idx) => {
        if (data[key].Designable) {
            preparedData[key] = data[key];
        } else if (typeof data[key] == 'object') {
            Object.keys(data[key]).forEach((subkey, idx) => {
                if (data[key][subkey].Designable && data[key][subkey].Label) {
                    preparedData[data[key][subkey].Key] = { ...data[key][subkey] };
                    preparedData[data[key][subkey].Key].Label = key + ' - ' + window.Dictionary.getTranslation(data[key][subkey].Label);
                }
            });
        }
    });
    return preparedData;
}
